import React, { useEffect } from "react";
import { Form, Image } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { Facility, BidFormInput } from "../types/type";


export const initialData_plan2 = [
    {
        usage_1: 0,
        usage_2: 0,
    },
    {
        usage_1: 0,
        usage_2: 0,
    }, {
        usage_1: 0,
        usage_2: 0,
    }, {
        usage_1: 0,
        usage_2: 0,
    }, {
        usage_1: 0,
        usage_2: 0,
    }

];
const Plan2: React.FC<{ facility: Facility, confirm: boolean }> = ({ facility, confirm }) => {
    const { control, watch, setValue } = useFormContext<BidFormInput>();
    const is_custom = watch(`conditions.${facility.id}.is_custom`);
    const custom_check_1 = watch(`conditions.${facility.id}.custom_check_1`);
    const custom_check_2 = watch(`conditions.${facility.id}.custom_check_2`);
    const custom_check_3 = watch(`conditions.${facility.id}.custom_check_3`);

    let visible = false;
    if (is_custom) {
        visible = (custom_check_1 && !custom_check_2 && !custom_check_3);
    } else {
        visible = (facility.contract_type == "LOAD_FACTOR" || facility.contract_type == "LOW_LOAD_STEP");
    }
    const record = 5;

    const getUsage = () => {
        return Array.from({ length: record }, (_, i) => (
            <tr key={i}>
                <td className="w-m-140 py-2">
                    <div className="input-group" style={{ display: "none" }}>

                        <div className="input-group-append">
                            <Image className="img img-fluid ml-3" width="15" src="assets/images/bidding-condition/percentage.svg" />
                        </div>
                    </div>
                    <div className="input-group">
                        <span>第{i + 1}段階</span>
                    </div>
                </td>
                <td className="w-m-140 py-2">
                    <div className="input-group">
                        <Controller
                            name={`conditions.${facility.id}.usage.${i}.usage_1`}
                            control={control}
                            rules={{
                                required: { value: true, message: "必須入力" },
                                validate: (value) => {
                                    if (value !== null || "") {
                                        return true;
                                    }
                                    return "数値を入力してください";
                                },
                            }}
                            render={({ field }) => (
                                <input className="form-control mb-3 rounded-0 name-required  text-right"
                                    {...field}
                                    placeholder=""
                                    disabled={confirm}
                                    type="number"

                                />
                            )}
                        />

                        <div className="input-group-append">
                            <img className="img img-fluid ml-3" width="15" src="assets/images/bidding-condition/kwh.svg" alt="kwh" />
                        </div>
                    </div>
                </td>
                <td className="w-m-140 py-2" style={facility.contract_type === "LOW_LOAD_STEP" ? { display: 'none' } : {}}>
                    <div className="input-group">
                        <Controller
                            name={`conditions.${facility.id}.usage.${i}.usage_2`}
                            control={control}
                            rules={{
                                required: { value: true, message: "必須入力" },
                                validate: (value) => {
                                    if (value !== null || "") {
                                        return true;
                                    }
                                    return "数値を入力してください";
                                },
                            }}
                            render={({ field }) => (
                                <input className="form-control mb-3 rounded-0 name-required  text-right"
                                    {...field}
                                    placeholder=""
                                    disabled={confirm}
                                    type="number"
                                />
                            )}
                        />
                        <div className="input-group-append">
                            <img className="img img-fluid ml-3" width="15" src="assets/images/bidding-condition/kwh.svg" alt="kwh" />
                        </div>
                    </div>
                </td>



            </tr>
        ));
    }


    return (
        <table className={`table table-bordered table-vertical-align-middle text-center ${visible ? '' : 'd-none'}`}>
            <thead>
                <tr>
                    <td scope="col" className="bg-ass-table fw-400 py-1">{facility.contract_type == "LOW_LOAD_STEP" ? "段階" : "負荷率"}</td>
                    <td scope="col" className="bg-ass-table fw-400 py-1">{facility.contract_type == "LOW_LOAD_STEP" ? "単価" : "夏季"}</td>
                    <td scope="col" className={`bg-ass-table fw-400 py-1 ${facility.contract_type == "LOW_LOAD_STEP" ? "d-none" : ""}`}>その他季</td>
                </tr>
            </thead>
            <tbody className="bg-white">
                {getUsage()}
            </tbody>
        </table>
    );
};

export default Plan2;
